import { render, staticRenderFns } from "./DanMu.vue?vue&type=template&id=79f19f16&scoped=true&"
import script from "./DanMu.vue?vue&type=script&lang=js&"
export * from "./DanMu.vue?vue&type=script&lang=js&"
import style0 from "./DanMu.vue?vue&type=style&index=0&id=79f19f16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f19f16",
  null
  
)

export default component.exports